/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Internatsschule_Schloss_Hansenberg3Inputs */

const en__field_enum_internatsschule_schloss_hansenberg3 = /** @type {(inputs: _Field_Enum_Internatsschule_Schloss_Hansenberg3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geisenheim-Johannisberg`)
};

const de__field_enum_internatsschule_schloss_hansenberg3 = /** @type {(inputs: _Field_Enum_Internatsschule_Schloss_Hansenberg3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internatsschule Schloss Hansenberg`)
};

/**
* | output |
* | --- |
* | "Geisenheim-Johannisberg" |
*
* @param {_Field_Enum_Internatsschule_Schloss_Hansenberg3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_internatsschule_schloss_hansenberg3 = /** @type {((inputs?: _Field_Enum_Internatsschule_Schloss_Hansenberg3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Internatsschule_Schloss_Hansenberg3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_internatsschule_schloss_hansenberg3(inputs)
	return de__field_enum_internatsschule_schloss_hansenberg3(inputs)
});
export { _field_enum_internatsschule_schloss_hansenberg3 as "_field_enum_Internatsschule_Schloss_Hansenberg" }